import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { texts, images } from '../../settings';
import { Actions } from '../../flux';
import { Zoom, Fade } from 'react-reveal/';
import { DelayLink, CardAccordion, CardAccordionHeader, CardAccordionBody } from '../../components';
//Components
import { Hero } from '../../components/Hero';
import { CardTab } from '../../components/CardTab';

// Templates
import { Liquidez } from './templates/liquidez';
import { Distribuicao } from './templates/distribuicao';
import { Cross } from './templates/cross';
import { MercadoCapitais } from './templates/mercado-capitais';

import { Autoregulacao } from './templates/autoregulacao';
import { Inovacao } from './templates/inovacao';
import { Tributacao } from './templates/tributacao';

import './PlanoAcao2020.scss';

class PlanoAcao2020 extends Component {
  constructor(props) {
    super(props);
    this.texts = texts;
    this.images = images;
    this.scrollPositiva = React.createRef();
    this.scrollInst = React.createRef();
    this.state = {
      tabAtiva: 'null',
    };
  }

  scrollTop = () => {
    window.scrollTo({ top: 0 });
  };

  saibaMais = selecionado => {
    this.setState({
      tabAtiva: selecionado,
    });
    this.scroll.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render() {
    return (
      <div className="views views--plano-acao-2020">
        <Helmet>
          <title>{this.texts.title}</title>
        </Helmet>

        <div className="pa2019 page-gradient page-gradient--green bg-gray" ref="pa2019">
          <section className="governanca-home-area governanca-header page-gradient__header">
            <div className="container tela-max-plano">
              <div className="page-header">
                <h1 className="page-header__title tituto-top">
                  <img src={this.images.plano_acao_2019.icon_titulo_top} />
                  Resultados do
                  <br className="mobile" /> plano de <br className="mobile" />
                  ação 2020
                  <span className="gri_label_top">
                    GRI <b>102-21, 103-1, 103-2, 103-3 | 203-1, 203-2</b>
                  </span>
                </h1>
              </div>
            </div>
            <div className="container tela-max-top-plano">
              <div className="row flex center">
                <div className="col-6">
                  <Fade bottom>
                    <div className="page-header pading-medio">
                      <p className="page-header__description gri_text_top_desc">
                        No segundo semestre de cada ano, elaboramos o plano de ação que norteia nosso trabalho no ano
                        seguinte. Ele é construído a partir de conversas com os associados e leva em conta as tendências
                        dos mercados brasileiro e internacional.
                      </p>
                      <p className="page-header__description gri_text_top_desc">
                        Lançado inicialmente em dezembro de 2019, o plano de 2020 estava dividido em duas vertentes: as
                        pautas específicas de mercado, que nasceram em discussões nos fóruns de representação, e a pauta
                        institucional, que pode ser tocada dentro de casa e inclui ações relacionadas às atividades
                        rotineiras da ANBIMA na defesa dos interesses dos associados.
                      </p>
                    </div>
                  </Fade>
                </div>
                <div className="anime-top col-6">
                  <div className="row">
                    <Fade>
                      <div className="col-12 pessoas-animadas">
                        <img src={this.images.plano_acao_2019.pessoa_top} className="pessoa_top_plano" />
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
              <div className="row-12 texto-top-2">
                <Fade bottom>
                  <p className="page-header__description gri_text_top_desc">
                    Entretanto, com os novos desafios impostos pela pandemia, o plano de ação para 2020 foi revisado com
                    a colaboração dos fóruns e grupos de trabalho formados por representantes das instituições
                    associadas. A nova versão foi divulgada em junho de 2020. Os ajustes refletiram as demandas e
                    preocupações dos associados e o novo cenário econômico, incluindo a participação que é esperada do
                    mercado de capitais para a retomada do crescimento.
                  </p>
                  <p className="page-header__description gri_text_top_desc">
                    O primeiro bloco do plano, o das pautas específicas, passou a ser denominado Agenda Positiva,
                    formado por quatro temas que ganharam força com a crise. São eles: liquidez, distribuição,
                    investimento crossborder e mercado de capitais. O segundo bloco manteve os mesmos três temas
                    institucionais da primeira versão: autorregulação, inovação e tributação.
                  </p>
                </Fade>
              </div>
            </div>
          </section>
        </div>

        <Fade right>
          <div className="container container-white tela-max-plano center">
            <h1 className="titulo-meta-resumo-e-atividades">Confira o resumo do que foi feito</h1>
            <h2 className="titulo-agenda-green">Agenda positiva</h2>
            <div className="container plano-tabs" ref={this.scrollPositiva}>
              <CardTab
                saibaMais={this.saibaMais.bind(this)}
                seleciona="liquidez"
                cor="green"
                titulo="Liquidez"
                selecionado={this.state.tabAtiva}
              />
              <div className="container conteudo-tab conteudo-mobile">
                {this.state.tabAtiva == 'liquidez' && <Liquidez cor="#78BC42" />}
              </div>
              <CardTab
                saibaMais={this.saibaMais.bind(this)}
                seleciona="distribuicao"
                cor="green"
                titulo="Distribuição"
                selecionado={this.state.tabAtiva}
              />
              <div className="container conteudo-tab conteudo-mobile">
                {this.state.tabAtiva == 'distribuicao' && <Distribuicao cor="#78BC42" />}
              </div>
              <CardTab
                saibaMais={this.saibaMais.bind(this)}
                seleciona="cross"
                cor="green"
                titulo="Investimento CrossBorder"
                selecionado={this.state.tabAtiva}
              />
              <div className="container conteudo-tab conteudo-mobile">
                {this.state.tabAtiva == 'cross' && <Cross cor="#78BC42" />}
              </div>
              <CardTab
                saibaMais={this.saibaMais.bind(this)}
                seleciona="mercado-capitais"
                cor="green"
                titulo="Mercado de Capitais"
                selecionado={this.state.tabAtiva}
              />
              <div className="container conteudo-tab conteudo-mobile">
                {this.state.tabAtiva == 'mercado-capitais' && <MercadoCapitais cor="#78BC42" />}
              </div>
            </div>
          </div>

          <div className="container conteudo-tab conteudo-desk">
            {this.state.tabAtiva == 'liquidez' && <Liquidez cor="#78BC42" />}
            {this.state.tabAtiva == 'distribuicao' && <Distribuicao cor="#78BC42" />}
            {this.state.tabAtiva == 'cross' && <Cross cor="#78BC42" />}
            {this.state.tabAtiva == 'mercado-capitais' && <MercadoCapitais cor="#78BC42" />}
          </div>
        </Fade>

        <Fade right>
          <div className="container container-white tela-max-plano pading--institucional margin-top-large center institucional">
            <h2 className="titulo-agenda-blue">Agenda institucional</h2>
            <div className="container plano-tabs" ref={this.scrollInst}>
              <CardTab
                saibaMais={this.saibaMais.bind(this)}
                seleciona="autoregulacao"
                cor="blue"
                titulo="Autorregulação"
                selecionado={this.state.tabAtiva}
              />
              <div className="container conteudo-tab conteudo-mobile">
                {this.state.tabAtiva == 'autoregulacao' && <Autoregulacao cor="#0F91D4" />}
              </div>
              <CardTab
                saibaMais={this.saibaMais.bind(this)}
                seleciona="inovacao"
                cor="blue"
                titulo="Inovação"
                selecionado={this.state.tabAtiva}
              />
              <div className="container conteudo-tab conteudo-mobile">
                {this.state.tabAtiva == 'inovacao' && <Inovacao cor="#0F91D4" />}
              </div>
              <CardTab
                saibaMais={this.saibaMais.bind(this)}
                seleciona="tributacao"
                cor="blue"
                titulo="Tributação"
                selecionado={this.state.tabAtiva}
              />
              <div className="container conteudo-tab conteudo-mobile">
                {this.state.tabAtiva == 'tributacao' && <Tributacao cor="#0F91D4" />}
              </div>
            </div>
          </div>

          <div className="container conteudo-tab conteudo-desk">
            {this.state.tabAtiva == 'autoregulacao' && <Autoregulacao cor="#0F91D4" />}
            {this.state.tabAtiva == 'inovacao' && <Inovacao cor="#0F91D4" />}
            {this.state.tabAtiva == 'tributacao' && <Tributacao cor="#0F91D4" />}
          </div>
        </Fade>

        <Fade bottom>
          <div className="container box-footer tela-max-plano">
            <div className="row">
              <div className="">
                <Fade>
                  <div className="box-pill box-pill--blue box-pill--center">
                    <div className="box-pill__content box-pill__content--full">
                      <div className="row">
                        <div className="col col-9 col--text col--text--end">
                          <h4>Confira as nossas relações institucionais</h4>
                          <DelayLink
                            to="/relacionamentos"
                            className="button button--aylen button--white-to-blue button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Saiba mais
                          </DelayLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    );
  }
}
export { PlanoAcao2020 };
